import toast from "react-hot-toast";

import { FeaturedIconProps } from "@/components/atoms/FeaturedIcon";
import Toast from "@/components/atoms/Toast";

type BannerProps = {
  heading: string;
  onClose?: () => void;
  isCloseable?: boolean;
  children?: React.ReactNode;
  featuredIcon?: {
    icon: FeaturedIconProps["icon"];
    color?: FeaturedIconProps["color"];
  };
};

export const useToast = () => {
  const showToast = ({ featuredIcon, heading, onClose, isCloseable = true, children }: BannerProps) => {
    toast.custom((t) => (
      <Toast
        heading={heading}
        isVisible={t.visible}
        isCloseable={isCloseable}
        featuredIcon={featuredIcon}
        onClose={() => {
          if (onClose) onClose();
          toast.dismiss(t.id);
        }}
      >
        {children}
      </Toast>
    ));
  };

  return { showToast };
};
